

import type { TIllustrationAssetProps } from "../helper";
import { ILLUSTRATION_COLOR_TOKEN_MAP } from "../helper";

export function UnknownHorizontalStackIllustration({ className }: TIllustrationAssetProps) {
  return (
    <svg
      width="71"
      height="80"
      viewBox="0 0 71 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g opacity="0.2">
        <path
          d="M41.6309 2.01885C40.8299 1.61147 39.8011 1.64599 38.6826 2.21218L7.84613 17.9273C5.3121 19.2185 3.2545 22.7675 3.2545 25.847V63.3741C3.2545 65.0934 3.88973 66.3017 4.89092 66.8196L1.81142 65.2522C0.810239 64.7412 0.174988 63.526 0.174988 61.8067V24.2796C0.174988 21.1932 2.23261 17.6511 4.76664 16.3599L35.6031 0.644812C36.7285 0.071721 37.7573 0.0441004 38.5514 0.451478L41.6309 2.01885Z"
          fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.secondary}
          stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.primary}
          strokeWidth="0.35"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M41.6309 2.01984C42.6321 2.53079 43.2674 3.74602 43.2674 5.46529V42.9924C43.2674 46.0788 41.2098 49.6209 38.6757 50.9121L7.83929 66.6272C6.71383 67.2003 5.68503 67.2279 4.89099 66.8205C3.88981 66.3096 3.25458 65.0944 3.25458 63.3751V25.848C3.25458 22.7616 5.31218 19.2195 7.84621 17.9283L38.6826 2.21317C39.8081 1.64008 40.8369 1.61246 41.6309 2.01984Z"
          fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.primary}
          stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.primary}
          strokeWidth="0.35"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g opacity="0.6">
        <path
          d="M55.0813 7.99932C54.2804 7.59194 53.2516 7.62646 52.133 8.19265L21.2966 23.9078C18.7625 25.1989 16.7049 28.748 16.7049 31.8275V69.3546C16.7049 71.0738 17.3402 72.2822 18.3414 72.8L15.2618 71.2327C14.2607 70.7217 13.6254 69.5065 13.6254 67.7872V30.2601C13.6254 27.1737 15.683 23.6316 18.2171 22.3404L49.0535 6.62528C50.179 6.05219 51.2078 6.02457 52.0018 6.43195L55.0813 7.99932Z"
          fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.secondary}
          stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.primary}
          strokeWidth="0.35"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M55.0813 8.00031C56.0825 8.51126 56.7177 9.72649 56.7177 11.4458V48.9729C56.7177 52.0593 54.6601 55.6014 52.1261 56.8926L21.2896 72.6077C20.1642 73.1808 19.1354 73.2084 18.3413 72.801C17.3401 72.2901 16.7049 71.0748 16.7049 69.3556V31.8285C16.7049 28.7421 18.7625 25.1999 21.2965 23.9088L52.133 8.19364C53.2584 7.62055 54.2872 7.59293 55.0813 8.00031Z"
          fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.primary}
          stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.primary}
          strokeWidth="0.35"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M68.5386 13.9505C67.7376 13.5431 66.7089 13.5776 65.5903 14.1438L34.7538 29.8589C32.2198 31.1501 30.1622 34.6991 30.1622 37.7786V75.3057C30.1622 77.025 30.7974 78.2333 31.7986 78.7512L28.7191 77.1838C27.718 76.6729 27.0827 75.4576 27.0827 73.7384V36.2113C27.0827 33.1249 29.1403 29.5828 31.6744 28.2916L62.5108 12.5765C63.6362 12.0034 64.6651 11.9757 65.4591 12.3831L68.5386 13.9505Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.secondary}
        stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.primary}
        strokeWidth="0.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M68.5386 13.9515C69.5398 14.4624 70.175 15.6777 70.175 17.3969V54.924C70.175 58.0104 68.1174 61.5526 65.5834 62.8437L34.7469 78.5589C33.6215 79.132 32.5927 79.1596 31.7986 78.7522C30.7975 78.2412 30.1622 77.026 30.1622 75.3067V37.7796C30.1622 34.6932 32.2198 31.1511 34.7539 29.8599L65.5903 14.1448C66.7158 13.5717 67.7446 13.5441 68.5386 13.9515Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.primary}
        stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.primary}
        strokeWidth="0.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.1524 53.1343C50.6553 53.3898 50.2548 53.1067 50.2548 52.506C50.2548 51.9053 50.6484 51.2148 51.1455 50.9593H51.1524C51.6496 50.7038 52.0501 50.9869 52.0501 51.5876C52.0501 52.1884 51.6496 52.8788 51.1524 53.1343Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.quaternary}
      />
      <path
        d="M56.5244 55.8546L45.7738 61.33C44.2892 62.0826 43.0878 61.2333 43.0878 59.4312V41.9899C43.0878 40.1878 44.2961 38.1026 45.7738 37.35L53.8384 33.2417C54.0732 33.1174 54.3011 33.1174 54.4737 33.2417L58.9548 36.4109C59.1206 36.5283 59.2172 36.7562 59.2172 37.0461V51.2146C59.2172 53.0167 58.0089 55.102 56.5313 55.8546H56.5244ZM45.7738 39.5249C45.2766 39.7735 44.8761 40.4709 44.8761 41.0716V58.5129C44.8761 59.1136 45.2766 59.3967 45.7738 59.1481L56.5244 53.6727C57.0215 53.4241 57.422 52.7267 57.422 52.126V38.4064L53.4656 35.61L45.7738 39.5318V39.5249Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.quaternary}
      />
      <path
        d="M51.0766 48.8175C50.7037 49.0108 50.3516 48.9003 50.2273 48.5068C50.0685 48.0165 50.324 47.2708 50.7935 46.8427C51.3321 46.3456 52.8718 44.6747 52.8718 43.5492C52.8718 42.6516 52.3885 42.0785 51.6911 42.1268C51.2423 42.1613 50.7521 42.4306 50.324 42.9001C49.889 43.3697 49.5645 43.9704 49.3987 44.6056C49.2261 45.2616 48.7152 45.807 48.2526 45.8416C47.7899 45.8761 47.5483 45.372 47.714 44.7161C48.3907 42.113 50.4483 39.8897 52.3056 39.7654C53.7073 39.6687 54.6532 40.8218 54.667 42.6309C54.667 45.5239 51.7049 48.3134 51.3666 48.6242C51.2699 48.7139 51.1802 48.7761 51.0835 48.8244L51.0766 48.8175Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.quaternary}
      />
    </svg>
  );
}
